import React from 'react';
import { BringzzAccordion, BringzzText, BringzzIcon } from "@bringzz/components";
import { useTranslation } from 'react-i18next';
import DefaultProductImage from 'assets/DefaultProductImage.png';

const BringzzOrderCardSmallAccordion = ({ totalPrice, products, fees, defaultExpanded = false }) => {
    const { t } = useTranslation();
    const parsedTotalPrice = parseFloat(totalPrice) || 0;
    const parsedDeliveryFee = parseFloat(fees) || 0;
    const subtotal = parsedTotalPrice - parsedDeliveryFee;

    return (
        <BringzzAccordion
            defaultValue={defaultExpanded}
            title={<div className='flex space-x-4'>
                <div>
                    <BringzzIcon
                        folder='LineIcons'
                        icon='IconCheckBoxAlt'
                        size='22'
                        className='p-3 rounded-full' />
                </div>
                <div>
                    <BringzzText tag='h3'>{t('component.orders.title')}</BringzzText>
                    <BringzzText tag='h4' className={"font-normal"}>{t('component.basket.summary.total')}: €{parsedTotalPrice.toFixed(2)}</BringzzText>
                </div>
            </div>}
            className='border-t'
        >
            <div className='px-4'>
                {products && products.length > 0 ? (
                    products.map((product, index) => (
                        <div
                            key={product.productIntegrationId || index}
                            className='flex justify-between items-start border-b pb-4 mb-4'
                        >
                            {/* Left Section: Product Image */}
                            <div className='w-1/5'>
                                <img
                                    src={product.productImage || DefaultProductImage}
                                    alt={product.name || 'Product Image'}
                                    className='w-full h-auto rounded'
                                />
                            </div>

                            {/* Middle Section: Product Details */}
                            <div className='w-3/5 px-2 flex flex-col'>
                                <BringzzText tag='h4' className='font-semibold text-sm'>
                                    {product.name || 'Product Name'}
                                </BringzzText>
                                <BringzzText className='text-gray-500 text-xs'>
                                    {product.manufacturer || 'Manufacturer'}
                                </BringzzText>
                                <div className='text-xs mt-1'>
                                    <span>{`${product.packaging || ''} | ${product.packageQuantity || ''}` || ''}</span>
                                </div>
                                <div className='text-xs mt-1'>
                                    <span>Qty: {product.quantity || 1}</span>
                                </div>
                            </div>

                            {/* Right Section: Price */}
                            <div className='w-1/5 text-right flex flex-col items-end'>
                                <div className='text-lg font-semibold text-black'>
                                    € {product.price ? (product.price * (product.quantity || 1)).toFixed(2) : '0.00'}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className='text-center py-4'>
                        <BringzzText>No products in this order</BringzzText>
                    </div>
                )}
            </div>

            <div className='px-4 py-4 border-t'>
                <div className='justify-between flex mb-2'>
                    <BringzzText tag='h4' className='font-regular'>
                        {t('component.basket.summary.subtotal')}
                    </BringzzText>
                    <BringzzText tag='h4' className='font-regular'>
                        € {subtotal.toFixed(2)}
                    </BringzzText>
                </div>
                <div className='justify-between flex mb-2'>
                    <BringzzText tag='h4' className='font-regular'>
                        {t('component.basket.summary.delivery_fee')}
                    </BringzzText>
                    <BringzzText tag='h4' className='font-regular'>
                        € {parsedDeliveryFee.toFixed(2)}
                    </BringzzText>
                </div>
                <div className='justify-between flex mb-2'>
                    <div className='flex space-x-1 items-center'>
                        <BringzzText tag='h4' className='font-bold'>
                            {t('component.basket.summary.total')}
                        </BringzzText>
                        <BringzzIcon
                            icon="IconQuestionCircle"
                            folder="LineIcons"
                            className="h-4 w-4 cursor-pointer text-magic-lilac"
                            size="16"
                        />
                    </div>
                    <BringzzText tag='h4' className='font-bold'>
                        € {parsedTotalPrice.toFixed(2)}
                    </BringzzText>
                </div>
            </div>
        </BringzzAccordion>
    );
};

export default BringzzOrderCardSmallAccordion; 